// Shared helper for calling our own backend (never a third-party AI or
// Bibelthek endpoint directly from the browser — see server/README section
// "Why there's a server now").

const SESSION_KEY = 'vsb-session-id';

export function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

const ERROR_MESSAGES = {
  invalid_input: 'Diese Eingabe ist ungültig oder zu lang.',
  rate_limited: 'Zu viele Anfragen — bitte kurz warten und erneut versuchen.',
  request_in_progress: 'Es läuft bereits eine Anfrage — bitte warten, bis sie fertig ist.',
  budget_exhausted: 'Das Tageslimit für KI-Antworten ist erreicht. Bitte später erneut versuchen.',
  ai_disabled: 'Die KI-Funktion ist momentan deaktiviert.',
  timeout: 'Die Antwort hat zu lange gedauert. Bitte erneut versuchen.',
  upstream_error: 'Der KI-Dienst ist gerade nicht erreichbar.',
  unavailable: 'Dienst momentan nicht verfügbar. Bitte in Kürze erneut versuchen.',
  internal_error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
};

export class ApiError extends Error {
  constructor(code, status) {
    super(ERROR_MESSAGES[code] || ERROR_MESSAGES.internal_error);
    this.code = code;
    this.status = status;
  }
}

export async function postJson(path, body) {
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': getSessionId(),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new ApiError(data.error || 'internal_error', response.status);
  }
  return response.json();
}

export async function getJson(path) {
  const response = await fetch(path);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new ApiError(data.error || 'internal_error', response.status);
  }
  return response.json();
}
